import React from 'react';
import styles from './index.module.less';
import { useTranslation } from '@/modules/ReoI18n';
import type { ICustomizeRecommendData } from '@/interface';

type IProps = ICustomizeRecommendData;

const CompFourHotSearch: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    return (
        <>
            {props.data.length > 0 && (
                <div
                    className={ `${styles['four-hot-search']} text-center` }
                    id="hotLink">
                    <span>{t('page-not-found:hot-search')}:</span>
                    {props.data.map((item, index) => {
                        return (
                            <React.Fragment key={ item.title }>
                                <a href={ item.href }>{item.title}</a>
                                {index < props.data.length - 1 && <span className={ styles['divide'] }> / </span>}
                            </React.Fragment>
                        );
                    })}
                </div>
            )}
        </>
    );
};
export default CompFourHotSearch;
